module.exports = __webpack_public_path__ + "static/img/logo.12d19779.png";